<template>
    <div class="strategy-item">
        <Icon class="strategy-item__icon" :icon="data.icon"/>
        <div class="strategy-item__text-wrapper">
            <TitleDescription
                :title="data.title"
                :description="data.description"
            />
        </div>
    </div>
</template>

<script>
import TitleDescription from '@/components/Ecommerce/TitleDescription'
import Icon from '@/components/Theme/Icon'

export default {
    name: 'StrategyItem',
    components: {
        Icon,
        TitleDescription
    },
    props: {
        data: {
            type: Object
        }
    }
}
</script>

<style lang="scss" scoped>
$background: #090A3F; 
$item-width: 488px;
$item_between_space: 32px;
$item_radius: 8px;

.strategy-item {
    --title-fontsize: 20px;
    --title-lineheight: 28px;
    --title-margin-bottom: 12px;
    --description-fontsize: 16px;
    --description-lineheight: 24px;

    --title-color: #ffffff;
    --description-color: #ffffff;

    @media (max-width: 768px) {
        --title-fontsize: 18px;
        --title-lineheight: 24px;
        --title-margin-bottom: 6px;
    }

    width: 100%;
    max-width: $item-width;
    background: #090A3F;
    padding: 32px 40px 32px;
    border-radius: $item_radius;
    display: flex;
    align-items: flex-start;
    &:first-child {
        margin-right: $item_between_space;
        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }
        @media (max-width: 576px) {
            margin-bottom: 16px;
        }
    }
    &__icon {
        margin-right: 24px;   
        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 16px;
        }
    }
    &__text-wrapper {
        @media (max-width: 768px) {
            text-align: center;
        }
    }
    @media (max-width: 768px) { 
        flex-direction: column;
        align-items: center;
    }
    @media (max-width: 576px) {
        text-align: center;
        padding: 24px 40px;
    }
}
</style>>
